import { render, staticRenderFns } from "./BlocoAnuncio.vue?vue&type=template&id=6d8eca71&scoped=true"
import script from "./BlocoAnuncio.vue?vue&type=script&lang=js"
export * from "./BlocoAnuncio.vue?vue&type=script&lang=js"
import style0 from "./BlocoAnuncio.vue?vue&type=style&index=0&id=6d8eca71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8eca71",
  null
  
)

export default component.exports